<template>
  <div class="modal-overflow">
      <div class="row">
        <div class="col-md-12">
              <div class="form-group">
                <label>Search Name</label>
                <el-input type="text"
                       name="name"
                       v-validate="modelValidations.name"
                       v-model="queryName"
                       maxlength="100"
                       placeholder="Search Name"
                       clearable/>
                <small class="text-danger" style="display: block" v-show="errors.has('name')">
                  {{ getError('name') }}
                </small>
              </div>
        </div>
      </div>
    <div class="row">
      <div class="col-md-12">
        <button type="submit" @click.prevent="validateAndSubmit" class="btn btn-fill btn-info pull-right" :disabled="isProcessing">Save</button>
        <button type="button" @click="close" style="margin-right: 10px;" class="btn btn-fill btn-info pull-right">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {sync} from 'vuex-pathify'
import {NOT_FOUND, OK} from 'http-status-codes'
import {notifyError, notifySuccess, userMergePutPayload} from 'src/utilities/utils'
import {ptracGet} from 'src/utilities/ptracApi'

export default {
  props: ['data'],
  data () {
    return {
      queryName: '',
      isProcessing: false,
      modelValidations: {
        name: {
          required: true,
          max: 128
        }
      }
    }
  },

  computed: {
    user: sync('security@user'),
    ...mapGetters({
      userId: 'security/userId',
      itemsToRemoveJob: 'jobs/search/itemsToRemove',
      itemsToRemoveTask: 'tasks/search/itemsToRemove',
      savedJobQueries: 'security/savedJobQueries',
      savedTaskQueries: 'security/savedTaskQueries'
    })
  },
  methods: {
    close(queryName) {
      this.$emit('close')
      this.$eventHub.$emit('savedSearchClosed', queryName ? queryName : null)
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    async validateNameIsUnique(checkFromBackend = false) {
      const response = checkFromBackend? await this.$store.dispatch('security/getSavedQueries', this.data.type) : null
      const savedQueries = response || this[`saved${this.data.type}Queries`]

      return !Object.keys(savedQueries).includes(this.queryName)
    },
    async saveQuery() {
      const savedQuery = {[this.queryName]: {...this.data.query}}

      // Save query to frontend store
      const savedQueryEntries = Object.entries(savedQuery[this.queryName])

      // this is hideous - sorry, not sorry
      const savedQueryFiltered = {[this.queryName]: Object.fromEntries(
        savedQueryEntries.filter(([key, value]) => !this[`itemsToRemove${this.data.type}`].includes(key)
          && value != null && value !== '' && !(Array.isArray(value) && value.length === 0)))}

      this.$store.commit(`security/appendToSaved${this.data.type}Queries`, {...savedQueryFiltered})

      // retrieve fresh user record from the DB
      const userResponse = await ptracGet(`users/${this.userId}`)

      if (NOT_FOUND === userResponse.status) {
        notifyError(this, `User with ID ${this.userId} was not found. Unable to save ${this.data.type} search.`)
        return
      }

      // Replace user record in the DB
      if (OK === userResponse.status) {
        const user = userResponse.data
        user[`saved${this.data.type}Queries`] = this.user[`saved${this.data.type}Queries`]
        const payload = userMergePutPayload(user)
        const response = await this.$store.dispatch('save2', payload)

        if (OK === response.status) {
          notifySuccess(this, `${this.data.type} Query Saved Successfully`)
          // Update list of queries in parent component
          this.$eventHub.$emit('savedQueriesNamesList', this.savedQueriesNamesList)
          this.close(this.queryName)
          return
        }
      }

      notifyError(this, `Failed to save ${this.data.type} search`)
      this.close()
    },
    async validateAndSubmit() {
      this.isProcessing = true

      if (await this.$validator.validateAll()) {
        if (!await this.validateNameIsUnique()) {
          const message = 'A saved search named <strong>' + this.queryName + '</strong> already exists. Do you want to replace it with this new search?'
          const payload = {message, replace: this.saveQuery, showButton: true}
          this.$eventHub.$emit('show-modal-3', 'Confirm Replace', payload, '600px')
        } else {
          await this.saveQuery()
        }
      }

      this.isProcessing = false
    }
  }
}
</script>
